import { render, staticRenderFns } from "./JEditor.vue?vue&type=template&id=0944177c&scoped=true"
import script from "./JEditor.vue?vue&type=script&lang=js"
export * from "./JEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0944177c",
  null
  
)

export default component.exports